import { render, staticRenderFns } from "./OperaRoleWindow.vue?vue&type=template&id=643a9d62"
import script from "./OperaRoleWindow.vue?vue&type=script&lang=js"
export * from "./OperaRoleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports